import { FieldArray, useFormikContext } from 'formik';

import type { PriceMessage } from '../../../../types/PricesMessage';
import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { Box } from '../../../common/ui/Box';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import { createPriceComparePort } from '../utils/createPriceComparePort';

import { PortPriceInformation } from './PortPriceInformation';

interface PriceInfoSectionProps {
    isFetching: boolean;
    priceMap: Record<string, PriceMessage[]> | null;
    onEnquiryButtonClick: (portId?: string) => void;
}

export const PriceInfoSection = ({ isFetching, priceMap, onEnquiryButtonClick }: PriceInfoSectionProps) => {
    const { values } = useFormikContext<PriceCompareFormValues>();

    return (
        <FieldArray name="portInformation">
            {({ push, remove }) => (
                <Box>
                    {values.portInformation.map((port, index) => (
                        <PortPriceInformation
                            key={port.id}
                            index={index}
                            onEnquiryButtonClick={onEnquiryButtonClick}
                            onRemove={() => remove(index)}
                            isFetching={isFetching}
                            supplierData={port.portId ? priceMap?.[port.portId] : undefined}
                            portId={port.portId}
                            showRemoveIcon={values.portInformation.length > 1}
                        />
                    ))}

                    <Box width="200px" style={{ flexShrink: 0 }}>
                        <Button type="button" LeadingIcon={IconPlus} onClick={() => push(createPriceComparePort())}>
                            {translate('compare.addPort')}
                        </Button>
                    </Box>
                </Box>
            )}
        </FieldArray>
    );
};
